import { useBoundField, type FieldProps } from "../field-state";

export function Checkbox(props: FieldProps<"s-checkbox">) {
  const { field, error, dismissError, handleBlur } = useBoundField<boolean>();
  return (
    <s-checkbox
      {...props}
      name={field.name}
      checked={field.state.value}
      error={error}
      onChange={(event) => {
        dismissError();
        field.handleChange(event.currentTarget.checked);
      }}
      onBlur={handleBlur}
    />
  );
}
